import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articleCategories.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articleCategories.actionsLoading;
export const getItems = (state:RootState) => state.articleCategories.items;
export const getItemsSelect = (state:RootState) => state.articleCategories.dropDownItems;
export const getItemsCount = (state:RootState) => state.articleCategories.itemsCount;
export const getItemForEdit = (state:RootState) => state.articleCategories.itemForEdit;
export const getError = (state:RootState) => state.articleCategories.error;
export const getErrorAction = (state:RootState) => state.articleCategories.errorAction;
export const validationErrors = (state: RootState) => state.articleCategories.validationErrors;
